// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 235 ? "636737c7" : chunkId) + "." + {"235":"cda1f7cfccf5341d","268":"ba1b97901507fb35","647":"8548a0ebdcf8099a"}[chunkId] + ".js";
};